import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import API from '../utils/api';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [resendEmail, setResendEmail] = useState('');
  const [resendState, setResendState] = useState('idle'); // idle | sending | sent
  const calledRef = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode double-invoke in development
    if (calledRef.current) return;
    calledRef.current = true;

    API.get(`/auth/verify-email/${token}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  const handleResend = async (e) => {
    e.preventDefault();
    if (!resendEmail.trim()) return;
    setResendState('sending');
    try {
      await API.post('/auth/resend-verification-public', { email: resendEmail.trim() });
      setResendState('sent');
    } catch {
      setResendState('sent'); // always show success to avoid email enumeration
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#f4f6f9',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px', fontFamily: 'Arial, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0',
        padding: '48px 40px', maxWidth: 460, width: '100%', textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
      }}>
        <Link to="/" style={{ display: 'inline-block', marginBottom: 28 }}>
          <img src="/logo-inspira.png" alt="Inspira" style={{ height: 40, objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; }} />
        </Link>

        {status === 'loading' && (
          <>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
            <h2 style={{ color: 'var(--in-blue)', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Memverifikasi email...</h2>
            <p style={{ color: 'var(--in-text)', fontSize: 14 }}>Mohon tunggu sebentar.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: 'var(--in-blue)', fontSize: 22, fontWeight: 700, marginBottom: 10 }}>Email Terverifikasi!</h2>
            <p style={{ color: 'var(--in-text)', fontSize: 15, lineHeight: 1.7, marginBottom: 28 }}>
              Akun Anda telah aktif. Silakan login untuk mulai menggunakan platform.
            </p>
            <Link to="/login" style={{
              display: 'inline-block', background: 'var(--in-blue)', color: '#fff',
              padding: '12px 32px', borderRadius: 8, fontWeight: 700,
              fontSize: 15, textDecoration: 'none',
            }}>
              Masuk Sekarang
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔗</div>
            <h2 style={{ color: 'var(--in-blue)', fontSize: 22, fontWeight: 700, marginBottom: 10 }}>Link Sudah Kedaluwarsa</h2>
            <p style={{ color: 'var(--in-text)', fontSize: 15, lineHeight: 1.7, marginBottom: 28 }}>
              Link verifikasi ini sudah tidak berlaku atau sudah pernah digunakan.
              Masukkan email Anda untuk mendapatkan link baru.
            </p>

            {resendState === 'sent' ? (
              <div style={{
                background: '#f0fdf4', border: '1px solid #bbf7d0',
                borderRadius: 8, padding: '14px 20px', color: '#166534',
                fontSize: 14, marginBottom: 24,
              }}>
                Jika email Anda terdaftar dan belum diverifikasi, link baru telah dikirim. Cek inbox Anda.
              </div>
            ) : (
              <form onSubmit={handleResend} style={{ marginBottom: 20, textAlign: 'left' }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--in-text)', display: 'block', marginBottom: 6 }}>
                  Alamat Email
                </label>
                <input
                  type="email"
                  required
                  value={resendEmail}
                  onChange={e => setResendEmail(e.target.value)}
                  placeholder="email@contoh.com"
                  style={{
                    width: '100%', boxSizing: 'border-box',
                    padding: '10px 12px', border: '1px solid #ddd', borderRadius: 7,
                    fontSize: 14, marginBottom: 12, outline: 'none',
                  }}
                />
                <button
                  type="submit"
                  disabled={resendState === 'sending'}
                  style={{
                    width: '100%', background: 'var(--in-blue)', color: '#fff',
                    padding: '11px', borderRadius: 8, fontWeight: 700,
                    fontSize: 14, border: 'none', cursor: 'pointer', opacity: resendState === 'sending' ? 0.7 : 1,
                  }}
                >
                  {resendState === 'sending' ? 'Mengirim...' : 'Kirim Ulang Link Verifikasi'}
                </button>
              </form>
            )}

            <Link to="/login" style={{ fontSize: 13, color: 'var(--in-text)', textDecoration: 'underline' }}>
              Kembali ke Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
